// Shared utility functions for privacy components

export const generateHeadingId = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
};

export interface HeadingInfo {
  level: number;
  text: string;
  id: string;
}

export const extractHeadings = (markdown: string): HeadingInfo[] => {
  const lines = markdown.split('\n');
  const headings: HeadingInfo[] = [];

  lines.forEach((line) => {
    const trimmed = line.trim();
    if (trimmed.startsWith('# ')) {
      const text = trimmed.substring(2).trim();
      const id = generateHeadingId(text);
      headings.push({ level: 1, text, id });
    } else if (trimmed.startsWith('## ')) {
      const text = trimmed.substring(3).trim();
      const id = generateHeadingId(text);
      headings.push({ level: 2, text, id });
    } else if (trimmed.startsWith('### ')) {
      const text = trimmed.substring(4).trim();
      const id = generateHeadingId(text);
      headings.push({ level: 3, text, id });
    }
  });

  return headings;
};
